"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/** @deprecated `@faire/slate/icons/CircleFilled` instead */
export const CircleFilled = createSVGIcon(
  <circle cx="8" cy="8" r="8" fill="currentColor" />,
  "CircleFilled",
  { viewBox: "0 0 16 16", fill: "none", color: Core.icon.default } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
